import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";

const API_BASE = (
  process.env.REACT_APP_BACKEND_URL ||
  "http://127.0.0.1:8000"
).replace(/\/+$/, "");

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  const refreshAuth = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_BASE}/api/auth/me`,
        { withCredentials: true }
      );

      const currentUser = response.data?.user || null;
      setUser(currentUser);
      return currentUser;
    } catch (error) {
      setUser(null);

      if (error.response?.status !== 401) {
        console.error("Authentication check failed:", error);
      }

      return null;
    } finally {
      setCheckingAuth(false);
    }
  }, []);

  useEffect(() => {
    refreshAuth();
  }, [refreshAuth]);

  const logout = useCallback(async () => {
    await axios.post(
      `${API_BASE}/api/auth/logout`,
      {},
      { withCredentials: true }
    );

    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        checkingAuth,
        refreshAuth,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider.");
  }

  return context;
}